// reducers/auth/index.js

import { combineReducers } from 'redux';
import { token }           from './auth';

const authReducers = combineReducers({
  token
});

export default combineReducers({
  auth: authReducers
});